
import axiosInstance from './axiosInstance';
import { AxiosRequestConfig, AxiosResponse } from 'axios';

/**
 * A unified request wrapper using axiosInstance.
 * Automatically handles errors with try/catch.
 *
 * @param config - Standard Axios request configuration
 * @returns AxiosResponse or undefined if failed
 */
export const request = async <T = any>(config: AxiosRequestConfig): Promise<AxiosResponse<T> | undefined> => {
  try {
    const response = await axiosInstance.request<T>(config);
    return response;
  } catch (error) {
    console.error('Request failed:', error);
    return undefined;
  }
};